import React from 'react';
import styled from 'styled-components';

import CollapseSmall from '@rover/icons/svg/collapse-small.svg';
import ExpandSmall from '@rover/icons/svg/expand-small.svg';

export const StyledExpandSmall = styled(ExpandSmall)`
  fill: ${({ theme }) => theme.colors.green['700']};
  height: 100%;
  width: 25px;
`;
export const StyledCollapseSmall = styled(CollapseSmall)`
  fill: ${({ theme }) => theme.colors.green['700']};
  height: 100%;
  width: 25px;
`;
export type Props = {
  isOpen?: boolean;
};

const IconSelectArrow = ({ isOpen }: Props): JSX.Element =>
  isOpen ? <StyledCollapseSmall /> : <StyledExpandSmall />;

export default IconSelectArrow;
